import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, message } from 'antd';
import FormFields from './elements/form';
import { editCourse, deleteCourse } from '../../../../core/actions/coursePost';

class CourseForm extends Component {
  constructor(props) {
    super(props);
    var {courseData} = this.props
    this.state = {
      title: '',
      subTitle: '',
      description: '',
      tagName: '',
      tags: [],
      inputVisible: false,
      previewVisible: false,
      previewImage: '',
      selectedItem: null,
      requirementInput: '',
      showRequirementInput: false,
      showYouWillLearnInput: false,
      imageFileList: [],
      videoUrl: '',
      requirements: [],
      youWillLearn: [],
      loading: false,
      progress: 0
    };

    this.handleClose = this.handleClose.bind(this);
    this.showInput = this.showInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputConfirm = this.handleInputConfirm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveInputRef = this.saveInputRef.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleVideoChange = this.handleVideoChange.bind(this);
    this.handleSaveEditable = this.handleSaveEditable.bind(this);
    this.handleAddRequirement = this.handleAddRequirement.bind(this);
    this.handleAddYouWillLearn = this.handleAddYouWillLearn.bind(this);
    this.handleCancelRequirement = this.handleCancelRequirement.bind(this);
    this.handleCancelYouWillLearn = this.handleCancelYouWillLearn.bind(this);
    this.handleAddRequirementInput = this.handleAddRequirementInput.bind(this);
    this.handleAddYouWillLearnInput = this.handleAddYouWillLearnInput.bind(this);
    this.normFile = this.normFile.bind(this);
    this.handleCourseDelete = this.handleCourseDelete.bind(this)
    this.handleNewCourse = this.handleNewCourse.bind(this)
    this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this)
  }
  componentWillMount() {
    var {courseData} = this.props
      this.setState({
        ...courseData,
        imageFileList:[{thumbUrl:courseData.image,uid:0,name:"cover"}],
        videoUrl:courseData.video})
  }
  componentDidMount(){
    this.props.getMedia(this.props.profile.uid)
  }
  componentWillReceiveProps(nextProps) {
    const { uploadSuccess, uploadError, loading, progress } = nextProps.course;
    if (uploadSuccess) message.success(uploadSuccess);
    if (uploadError) message.error(uploadError);
    if (progress !== this.state.progress) this.setState({ progress });
    this.setState({ loading });
  }
  // eslint-disable-next-line class-methods-use-this
  normFile(e) {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  handleCourseDelete() {
    const { courseId } = this.props
    console.log(courseId)
    this.props.deleteCourse(courseId)
  }

  handleImageChange(fileList) {
    this.setState({ imageFileList: fileList });
  }
  handleVideoChange(videoUrl) {
    this.setState({ videoUrl });
  }
  handleSaveEditable(props) {
    const { itemName, itemValue } = props;
    this.setState({ [itemName]: itemValue });
  }
  handleAddRequirementInput() {
    this.setState({ showRequirementInput: true });
  }
  handleAddYouWillLearnInput() {
    this.setState({ showYouWillLearnInput: true });
  }
  handleAddRequirement(item) {
    const { requirements } = this.state;
    requirements.unshift(item);

    this.setState({ requirements, showRequirementInput: false });
  }
  handleAddYouWillLearn(item) {
    const { youWillLearn } = this.state;
    youWillLearn.unshift(item);

    this.setState({ youWillLearn, showYouWillLearnInput: false });
  }
  handleCancelRequirement() {
    this.setState({ showRequirementInput: false, requirementInput: '' });
  }
  handleCancelYouWillLearn() {
    this.setState({ showYouWillLearnInput: false });
  }
  handleClose(removedTag) {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags });
  }
  showInput() {
    this.setState({ inputVisible: true }, () => this.input.focus());
  }
  handleInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleInputConfirm() {
    const state = this.state;
    const tagName = state.tagName;
    let tags = state.tags;
    if (tagName && tags.indexOf(tagName) === -1) {
      tags = [...tags, tagName];
    }

    this.setState({
      tags,
      inputVisible: false,
      tagName: ''
    });
  }
  handleSubmitAsDraft(e) {
    const { courseData} = this.props;
    const { imageFileList, videoUrl, asDraft, isNewCourse } = this.state;
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err && imageFileList.length > 0 && videoUrl) {
        const courseInfo = {
          id:courseData.id,
          title: this.state.title,
          subTitle: this.state.subTitle,
          description: this.state.description,
          tags: this.state.tags,
          duration:this.state.duration,
          lessons: this.state.lessons,
          userName: this.state.userName,
          image: this.state.imageFileList[0].thumbUrl,
          courseVideo: this.state.videoUrl,
          requirements: this.state.requirements,
          youWillLearn: this.state.youWillLearn,
          asDraft: true,
          isNewCourse,
          created: courseData.created
        };
        this.props.editCourse(courseInfo);
      } else if (!imageFileList.length > 0 || !videoUrl) {
        if (!imageFileList.length > 0) {
          message.error('please add course thumbnail');
        } if (!videoUrl) {
          message.error('please add course promotional video');
        }
      }
      this.setState({ loading: false });
    });
  }
  handleSubmit(e) {
    const { courseData} = this.props;
    const { imageFileList, videoUrl, asDraft, isNewCourse } = this.state;
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err && imageFileList.length > 0 && videoUrl) {
        const courseInfo = {
          id:courseData.id,
          title: this.state.title,
          subTitle: this.state.subTitle,
          description: this.state.description,
          tags: this.state.tags,
          duration:this.state.duration,
          lessons: this.state.lessons,
          userName: this.state.userName,
          image: this.state.imageFileList[0].thumbUrl,
          courseVideo: this.state.videoUrl,
          requirements: this.state.requirements,
          youWillLearn: this.state.youWillLearn,
          asDraft: false,
          isNewCourse,
          created: courseData.created
        };
        this.props.editCourse(courseInfo);
      } else if (!imageFileList.length > 0 || !videoUrl) {
        if (!imageFileList.length > 0) {
          message.error('please add course thumbnail');
        } if (!videoUrl) {
          message.error('please add course promotional video');
        }
      }
      this.setState({ loading: false });
    });
  }
  saveInputRef(input) {
    this.input = input;
  }

  saveInputRef(input) {
    this.input = input;
  }

  handleNewCourse(checked) {
    this.setState({
      isNewCourse: checked
    })
  }

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    // console.log(this.props.sections)
    return (
      <FormFields
        {...this.state}
        courseData={this.props.courseData}
        uploadMedia={this.props.uploadMedia}
        refreshVideos={this.props.refreshVideos}
        refresh={this.props.refresh}
        getMedia={this.props.getMedia}
        profile={this.props.profile}
        media={this.props.media}
        getFieldDecorator={getFieldDecorator}
        setFieldsValue={setFieldsValue}
        handleCancel={this.handleCancel}
        handleChange={this.handleChange}
        handleClose={this.handleClose}
        handleImageChange={this.handleImageChange}
        handleVideoChange={this.handleVideoChange}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        saveInputRef={this.saveInputRef}
        handleInputConfirm={this.handleInputConfirm}
        showInput={this.showInput}
        normFile={this.normFile}
        handleSaveEditable={this.handleSaveEditable}
        handleAddRequirement={this.handleAddRequirement}
        handleAddYouWillLearn={this.handleAddYouWillLearn}
        handleAddYouWillLearnInput={this.handleAddYouWillLearnInput}
        handleDeleteYouWillLearn={this.handleDeleteYouWillLearn}
        handleCancelRequirement={this.handleCancelRequirement}
        handleCancelYouWillLearn={this.handleCancelYouWillLearn}
        handleAddRequirementInput={this.handleAddRequirementInput}
        handleDelete={this.handleDelete}
        handleCourseDelete={this.handleCourseDelete}
        handleNewCourse={this.handleNewCourse}
        handleSubmitAsDraft={this.handleSubmitAsDraft}
      />
    );
  }
}
const CourseUploadForm = Form.create()(CourseForm);

// const mapStateToProps = state => ({
//   course: state.course,
//   firebase: state.firebase
// });

// const mapDispatchToProps = dispatch => ({
//   editCourse: courseInfo => dispatch(editCourse(courseInfo)),
//   deleteCourse: courseId => dispatch(deleteCourse(courseId))
// });

export default CourseUploadForm;
